(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tsf-halloween-giveaway"] && !Shopify.designMode) return;
  try {
    
/* ========================================================================== 
   TSF Halloween 2026 Giveaway #01
   1. Primary entry: native Klaviyo Client Subscriptions submission
   2. AMOE: UTM capture into hidden Shopify contact fields
   Theme Editor safe. No inline handlers. No third-party libraries.
   ========================================================================== */
(function () {
  var UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content'];
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  var REVISION = '2026-07-15';

  /* ---------- Giveaway hard-close guard ---------- */
  function closeTimestamp(scope) {
    if (!scope) { return null; }
    var raw = scope.getAttribute('data-close-at');
    if (!raw) { return null; }
    var parsed = Date.parse(raw);
    return Number.isNaN(parsed) ? null : parsed;
  }

  function giveawayIsClosed(scope) {
    var cutoff = closeTimestamp(scope);
    return cutoff !== null && Date.now() >= cutoff;
  }

  function enforceGiveawayClose(scope) {
    if (!scope || !giveawayIsClosed(scope)) { return false; }

    scope.setAttribute('data-effective-status', 'closed');

    var heroInner = scope.querySelector('.tsf-giveaway__hero-inner');
    if (heroInner && !heroInner.querySelector('.tsf-giveaway__statusflag--closed')) {
      var flag = document.createElement('p');
      flag.className = 'tsf-giveaway__statusflag tsf-giveaway__statusflag--closed';
      flag.textContent = 'Giveaway closed.';
      heroInner.appendChild(flag);
    }

    var primaryPanel = scope.querySelector('[data-tsf-entry]');
    if (primaryPanel) {
      primaryPanel.hidden = true;
      var primaryBand = primaryPanel.closest('.tsf-giveaway__band--primary');
      var primaryHeading = primaryBand ? primaryBand.querySelector('.tsf-giveaway__h2') : null;
      if (primaryHeading) { primaryHeading.textContent = 'Giveaway closed.'; }
    }

    var amoeForm = scope.querySelector('[data-tsf-giveaway-amoe]');
    if (amoeForm) {
      amoeForm.hidden = true;
      var amoeWrap = amoeForm.closest('.tsf-giveaway__wrap');
      if (amoeWrap && !amoeWrap.querySelector('[data-tsf-client-closed]')) {
        var closedCopy = document.createElement('p');
        closedCopy.className = 'tsf-giveaway__amoe-foot';
        closedCopy.setAttribute('data-tsf-client-closed', 'true');
        closedCopy.textContent = 'Entry for Giveaway #01 is closed. The Official Rules remain available above.';
        amoeWrap.appendChild(closedCopy);
      }
    }

    return true;
  }

  function initCloseGuard(root) {
    if (!root || !root.querySelectorAll) { return; }
    var scopes = root.querySelectorAll('[data-tsf-giveaway]');
    if (root.hasAttribute && root.hasAttribute('data-tsf-giveaway')) { scopes = [root]; }

    Array.prototype.forEach.call(scopes, function (scope) {
      if (scope.getAttribute('data-tsf-close-guard') === '1') { return; }
      scope.setAttribute('data-tsf-close-guard', '1');

      scope.addEventListener('submit', function (event) {
        if (!giveawayIsClosed(scope)) { return; }
        event.preventDefault();
        event.stopImmediatePropagation();
        enforceGiveawayClose(scope);
      }, true);

      if (enforceGiveawayClose(scope)) { return; }

      var cutoff = closeTimestamp(scope);
      if (cutoff === null) { return; }
      var remaining = cutoff - Date.now();
      if (remaining > 0) {
        window.setTimeout(function () { enforceGiveawayClose(scope); }, remaining + 250);
      }
    });
  }

  function readUtms() {
    var out = {};
    var params = null;
    try { params = new URLSearchParams(window.location.search); } catch (e) { params = null; }
    UTM_KEYS.forEach(function (key) {
      var fresh = params ? params.get(key) : null;
      if (fresh) {
        try { window.sessionStorage.setItem('tsf_' + key, fresh); } catch (e) {}
      }
      var stored = null;
      try { stored = window.sessionStorage.getItem('tsf_' + key); } catch (e) {}
      var value = fresh || stored;
      if (value) { out[key] = String(value).slice(0, 255); }
    });
    return out;
  }

  /* ---------- AMOE UTM capture ---------- */
  function fillAmoe(root) {
    if (!root || !root.querySelectorAll) { return; }
    var forms = root.querySelectorAll('[data-tsf-giveaway-amoe]');
    if (!forms.length) { return; }
    var utms = readUtms();
    for (var i = 0; i < forms.length; i++) {
      ['utm_source', 'utm_medium', 'utm_content'].forEach(function (key) {
        var input = forms[i].querySelector('[data-tsf-utm="' + key + '"]');
        if (input && utms[key]) { input.value = utms[key]; }
      });
    }
  }

  /* ---------- Primary Klaviyo entry ---------- */
  function initPrimary(root) {
    if (!root || !root.querySelectorAll) { return; }
    var scopes = root.querySelectorAll('[data-tsf-giveaway]');
    if (root.hasAttribute && root.hasAttribute('data-tsf-giveaway')) { scopes = [root]; }

    Array.prototype.forEach.call(scopes, function (scope) {
      if (scope.getAttribute('data-tsf-init') === '1') { return; }
      var panel = scope.querySelector('[data-tsf-entry]');
      if (!panel) { return; }
      var form = panel.querySelector('[data-tsf-form]');
      if (!form) { return; }
      scope.setAttribute('data-tsf-init', '1');

      var emailEl   = panel.querySelector('[data-tsf-email]');
      var rulesEl   = panel.querySelector('[data-tsf-rules]');
      var consentEl = panel.querySelector('[data-tsf-consent]');
      var hpEl      = panel.querySelector('[data-tsf-hp]');
      var btn       = panel.querySelector('[data-tsf-btn]');
      var msg       = panel.querySelector('[data-tsf-msg]');
      var success   = panel.querySelector('[data-tsf-success]');
      if (!emailEl || !rulesEl || !consentEl || !btn) { return; }

      var SITE     = scope.getAttribute('data-site-id');
      var LIST     = scope.getAttribute('data-list-id');
      var SOURCE   = scope.getAttribute('data-source');
      var CKEY     = scope.getAttribute('data-campaign-key');
      var CUTM     = scope.getAttribute('data-campaign-utm');
      var LOADING  = scope.getAttribute('data-loading-label');
      var LABEL    = btn.getAttribute('data-label');
      var ENDPOINT = 'https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(SITE);
      var leadSent = false;

      function showError(text, focusEl) {
        if (msg) { msg.textContent = text; msg.className = 'tsf-giveaway__perr is-visible'; }
        if (focusEl) { try { focusEl.focus(); } catch (e) {} }
      }
      function clearError() {
        if (msg) { msg.textContent = ''; msg.className = 'tsf-giveaway__perr'; }
      }
      function setLoading(on) {
        btn.disabled = on;
        btn.textContent = on ? LOADING : LABEL;
      }
      function trackLead() {
        if (leadSent) { return; }
        try {
          if (typeof window.fbq !== 'function') { return; }
          window.fbq('track', 'Lead', {
            content_name: 'TSF Halloween 2026 Giveaway #01',
            content_category: 'Giveaway Entry'
          });
          leadSent = true;
        } catch (e) { /* Meta must never interrupt the entry. */ }
      }
      function showSuccess() {
        panel.classList.add('is-done');
        if (success) {
          success.hidden = false;
          try { success.focus(); } catch (e) {}
        }
      }

      form.addEventListener('submit', function (event) {
        event.preventDefault();

        if (hpEl && hpEl.value !== '') { return; }

        var email = (emailEl.value || '').trim();
        if (!EMAIL_RE.test(email)) {
          showError(scope.getAttribute('data-msg-email'), emailEl);
          return;
        }

        if (!rulesEl.checked) {
          showError(scope.getAttribute('data-msg-rules'), rulesEl);
          return;
        }
        if (!consentEl.checked) {
          showError(scope.getAttribute('data-msg-consent'), consentEl);
          return;
        }

        clearError();
        setLoading(true);

        if (window.Shopify && window.Shopify.designMode) {
          window.setTimeout(function () { setLoading(false); showSuccess(); }, 700);
          return;
        }

        var props = readUtms();
        if (!props.utm_campaign) { props.utm_campaign = CUTM; }
        props.giveaway_campaign = CKEY;
        props.giveaway_entry_method = 'primary';
        props.giveaway_source = 'shopify_landing';
        props.giveaway_hw26_01_entered = true;
        props.giveaway_hw26_01_entered_at = new Date().toISOString();
        props.signup_page = SOURCE;

        var payload = {
          data: {
            type: 'subscription',
            attributes: {
              custom_source: SOURCE,
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: email,
                    properties: props,
                    subscriptions: {
                      email: { marketing: { consent: 'SUBSCRIBED' } }
                    }
                  }
                }
              }
            },
            relationships: { list: { data: { type: 'list', id: LIST } } }
          }
        };

        window.fetch(ENDPOINT, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/vnd.api+json',
            'Accept': 'application/vnd.api+json',
            'revision': REVISION
          },
          body: JSON.stringify(payload)
        }).then(function (response) {
          setLoading(false);
          if (response.status === 202 || (response.status >= 200 && response.status < 300)) {
            showSuccess();
            window.setTimeout(trackLead, 0);
          } else {
            showError(scope.getAttribute('data-msg-fail'), emailEl);
          }
        }).catch(function () {
          setLoading(false);
          showError(scope.getAttribute('data-msg-fail'), emailEl);
        });
      });
    });
  }

  function boot(root) {
    var context = root || document;
    initCloseGuard(context);
    fillAmoe(context);
    initPrimary(context);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }
  document.addEventListener('shopify:section:load', function (evt) { boot(evt.target || document); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tsf-homepage"] && !Shopify.designMode) return;
  try {
    
(function () {
  function pad(n){ return String(Math.max(0,n)).padStart(2,'0'); }
  document.querySelectorAll('.tsf-home [data-tsf-countdown]').forEach(function (el) {
    var deadline = new Date(el.getAttribute('data-deadline')).getTime();
    if (isNaN(deadline)) return;
    var inline = el.getAttribute('data-fmt') === 'inline';
    var dEl = el.querySelector('[data-unit="days"]'),
        hEl = el.querySelector('[data-unit="hours"]'),
        mEl = el.querySelector('[data-unit="mins"]'),
        sEl = el.querySelector('[data-unit="secs"]');
    function tick() {
      var diff = Math.max(0, deadline - Date.now());
      var d = Math.floor(diff/86400000); diff -= d*86400000;
      var h = Math.floor(diff/3600000); diff -= h*3600000;
      var m = Math.floor(diff/60000);   diff -= m*60000;
      var s = Math.floor(diff/1000);
      if (inline) { el.textContent = pad(d)+'D '+pad(h)+':'+pad(m)+':'+pad(s); return; }
      if (dEl) dEl.textContent = pad(d);
      if (hEl) hEl.textContent = pad(h);
      if (mEl) mEl.textContent = pad(m);
      if (sEl) sEl.textContent = pad(s);
    }
    tick();
    setInterval(tick, 1000);
  });

  /* ── TSF ASYNC KLAVIYO CAPTURE ── */
  document.querySelectorAll('.tsf-home[data-tsf-klaviyo]').forEach(function (root) {
    if (root.getAttribute('data-tsf-cap-init') === '1') { return; }
    root.setAttribute('data-tsf-cap-init', '1');

    var SITE_ID     = root.getAttribute('data-site-id');
    var LIST_ID     = root.getAttribute('data-list-id');
    var INVALID_MSG = root.getAttribute('data-invalid-msg') || 'Enter a valid email address.';
    var FAIL_MSG    = root.getAttribute('data-fail-msg') || 'We could not complete the signup. Try again.';
    var LOAD_LABEL  = root.getAttribute('data-loading-label') || 'SENDING...';
    var REVISION    = '2026-07-15';
    var ENDPOINT    = 'https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(SITE_ID);
    var UTM_KEYS    = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content'];
    var EMAIL_RE    = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

    function utms() {
      var out = {}, params = null;
      try { params = new URLSearchParams(window.location.search); } catch (e) {}
      UTM_KEYS.forEach(function (k) {
        var fresh = params ? params.get(k) : null;
        if (fresh) { try { window.sessionStorage.setItem('tsf_' + k, fresh); } catch (e) {} }
        var stored = null;
        try { stored = window.sessionStorage.getItem('tsf_' + k); } catch (e) {}
        var v = fresh || stored;
        if (v) { out[k] = v; }
      });
      return out;
    }

    root.querySelectorAll('[data-tsf-cap]').forEach(function (cap) {
      var form  = cap.querySelector('[data-tsf-form]');
      var input = cap.querySelector('[data-tsf-input]');
      var hp    = cap.querySelector('[data-tsf-hp]');
      var btn   = cap.querySelector('[data-tsf-btn]');
      var msg   = cap.querySelector('[data-tsf-msg]');
      if (!form || !input || !btn) { return; }

      var SOURCE    = cap.getAttribute('data-source') || 'Homepage Capture';
      var BTN_LABEL = btn.getAttribute('data-label') || btn.textContent;

      function showErr(t) { if (msg) { msg.textContent = t; msg.classList.add('is-on'); } }
      function clearErr() { if (msg) { msg.textContent = ''; msg.classList.remove('is-on'); } }
      function setLoading(on) { btn.disabled = on; btn.textContent = on ? LOAD_LABEL : BTN_LABEL; }
      function markDone(fire) {
        cap.classList.add('is-done');
        if (fire) { try { if (window.fbq) { window.fbq('track', 'Lead'); } } catch (e) {} }
      }

      form.addEventListener('submit', function (ev) {
        ev.preventDefault();
        if (hp && hp.value !== '') { return; }

        var email = (input.value || '').trim();
        if (!EMAIL_RE.test(email)) { showErr(INVALID_MSG); input.focus(); return; }

        clearErr();
        setLoading(true);

        var isThemePreview =
          (window.Shopify && window.Shopify.designMode) ||
          (window.Shopify && window.Shopify.theme && window.Shopify.theme.role && window.Shopify.theme.role !== 'main') ||
          /(?:\?|&)preview_theme_id=/.test(window.location.search);

        if (isThemePreview) {
          window.setTimeout(function () { setLoading(false); markDone(false); }, 700);
          return;
        }

        var props = utms();
        props.signup_page = SOURCE;

        window.fetch(ENDPOINT, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/vnd.api+json',
            'Accept': 'application/vnd.api+json',
            'revision': REVISION
          },
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                custom_source: SOURCE,
                profile: {
                  data: {
                    type: 'profile',
                    attributes: { email: email, properties: props }
                  }
                }
              },
              relationships: { list: { data: { type: 'list', id: LIST_ID } } }
            }
          })
        }).then(function (res) {
          setLoading(false);
          if (res.status === 202 || (res.status >= 200 && res.status < 300)) { markDone(true); }
          else { showErr(FAIL_MSG); }
        }).catch(function () {
          setLoading(false);
          showErr(FAIL_MSG);
        });
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
